import studentApi from '@/api/student'

const student={
  namespaced:true,
  state:{
    data:[],
    pagination:{current:1,total:0,pageSize:10,showSizeChanger:true,showTotal:total=>`总计 ${total} 条`},
    loading:false,
    sorter:{},
    baseinfos:[],
    schools:[],
    editStudent:{},
    studentClass:[]
  },
  mutations:{
    setData:(state,data)=>{
      state.data=data
    },
    setPagination:(state,pagination)=>{
      state.pagination=pagination
    },
    setLoading:(state,loading)=>{
      state.loading=loading
    },
    setSorter:(state,sorter)=>{
      state.sorter=sorter
    },
    setBaseInfos:(state,infos)=>{
      state.baseinfos=infos
    },
    setSchools:(state,schools)=>{
      state.schools=schools
    },
    edit:(state,student)=>{
      state.editStudent=student
    },
    setStudentClass:(state,classes)=>{
      state.studentClass=classes
    }
  },
  actions:{
    async GetStudents({ commit,state },pagination){
      commit('setLoading',true)
      const page={
        skipCount:pagination.pageSize*(pagination.current-1),
        maxResultCount:pagination.pageSize,
        ...pagination
      }           
      if(state.sorter.field){
        if(state.sorter.order==='ascend'){
          page.sorting=state.sorter.field
        }else{
          page.sorting=state.sorter.field+' desc'
        }
      }
      try{
        const res=await studentApi.getStudents(page)
        pagination.total=res.result.totalCount
        commit('setPagination',pagination)
        commit('setData',res.result.items)
      }finally {
        commit('setLoading',false)
      }
    },
    async UpdateOrAdd({ commit,dispatch,state },student){
      try{
        if(student.id){
          await studentApi.updateStudent(student)          
        }else{
          await studentApi.createStudent(student)
        }
        commit('edit',{})
        await dispatch('GetStudents',state.pagination)
      }catch(err){
        throw err
      }     
    },
    async GetBaseInfos({ commit },where){
      const res=await studentApi.getBaseInfos(where)
      commit('setBaseInfos',res.result.items)
    },
    async GetSchools({ commit }){
      commit
      const res=await studentApi.getSchools()
      commit('setSchools',res.result.items)
    },
    async GetEnrollClass({ commit },input){
      commit
      const res=await studentApi.getEnrollClass(input)
      return res.result.items
    },
    async GetStudentClass({ commit },input){
      const res=await studentApi.getStudentClass(input)
      commit('setStudentClass',res.result)
    }
  }
}
export default student